import { mergeProps } from 'src/util'
import React from 'react'
import PropTypes from 'prop-types'
import { Rows } from 'src/components'
import { BlockWrapper } from '../common'
import styles from './BlockToolbar.scss'

const BlockToolbar = ({ children, ...domProps }) => (
  <BlockWrapper {...mergeProps()({ className: styles.toolbar }, domProps)}>
    <Rows gap="1rem" className={styles.items}>
      {children}
    </Rows>
  </BlockWrapper>
)

BlockToolbar.propTypes = {
  children: PropTypes.node,
}

export default BlockToolbar
